export const DEVICE_SPECIFICATION_NAMES = {
  BRAND: 'brand',
  DEVICE_SELECTION_CATEGORY: 'deviceSelectionCategory',
  DEVICE_TYPE: 'deviceType',
} as const;

export type DeviceSpecificationNameCoCo = (typeof DEVICE_SPECIFICATION_NAMES)[keyof typeof DEVICE_SPECIFICATION_NAMES];
